import * as types from "../../Action/type";

const initialState = {
    loading: false,
    token: null,
    error: null,
    user: null,
    userType: null,
    verified: false,
    confirm: false,
    sucessRegister: false,
    closemenu: false,
    menuMobile: false,
    activeStudent: null,
    activeFalg: false
}
const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_LOGIN_REQUEST:
            return { ...state, loading: true, error: null };
        case types.FETCH_LOGIN_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                user: action.payload.user,
                activeStudent: action.payload.user.student ? action.payload.user.student.length > 0 && action.payload.user.student[0] : null,
                userType: action.payload.user.type
            };
        case types.FETCH_UPDATE_REQUEST:
            return {
                ...state,
                user: action.payload,
            };
        case types.REMOVE_TOKEN:
            return {
                ...state,
                token: null,
                userType: null,
                loading: false,
            };
        case types.FETCH_CONFIRM_ACCOUNT:
            return {
                ...state,
                verified: true,
                confirm: false
            }
        case types.ACCOUNT_NOT_VERIFIED:
            return {
                ...state,
                confirm: true,
                verified: false
            }
        case types.INTIALIZE_TOKEN:
            return {
                ...state,
                token: action.tokenPayload,
                user: action.userPayload,
                userType: action.typePayload,
                activeStudent: action.activeStudentPayload ? action.activeStudentPayload : null,
                loading: false,
            };
        case types.FETCH_ACTIVE_STUDENT_SUCCESS:
            return {
                ...state,
                activeStudent: action.payload,
                loading: false,
                activeFalg: true
            };

        case types.FETCH_SIGNUP_SUCCESS:
            return {
                ...state,
                sucessRegister: true
            }
        case types.RESET_SIGNUP_SUCCESS:
            return {
                ...state,
                sucessRegister: false
            }
        case types.CLOSE_MENU:
            return {
                ...state,
                closemenu: action.payload,
                loading: false,
            };
        case types.CLOSE_MENU_MOBILE:
            return {
                ...state,
                menuMobile: action.payload,
                loading: false,
            }
            // SET_USER_TYPE
            case types.SET_USER_TYPE:
                return {
                    ...state,
                    userType: action.payload,
                    loading: false,
                }
        default:
            return state;
    }

}
export default AuthReducer;